export const MobileHandler = (mobile) => {
var actiontype;
if (mobile === true) {
 console.log('mobile is '+mobile);
  actiontype = "MobileUser"
}
else if (mobile === false) {
  actiontype = "DesktopUser"

}
  return {
      type: actiontype,
  }
};



// WEBPACK FOOTER //
// ./src/actions/mobile-handler.js